<div [class.isCollapsible]="isCollapsible" class="flexColumnParent">
    <div (click)="isCollapsible && toggleCollapsed()" class="ac-separator-container flexRowParent flexItem">
        <div [id]="separatorId" [class.collapsible]="isCollapsible" class="ac-separator">
            <span [class.title-gap]="title" class="ac-separator-title">{{title ? title : ''}}</span>
        </div>

        <div *ngIf="isCollapsible" class="flexItem line-separator-arrow">
            <ac-svg width="8px" name="chevron" [rotate]="collapsed ? -90 : 90"></ac-svg>
        </div>
    </div>

    <div *ngIf="isCollapsible && !collapsed" [class.collapsed]="collapsed"
         class="line-separator-content flexItemBiggest">
        <div class="flexColumnParent">
            <ng-content></ng-content>
        </div>
    </div>
</div>
